import classNames from "classnames";

import { CheckMarkIcon } from "@/components/data-display/icon";
import { formatStatus } from "@/utils/helpers";

import Styles from "./step.module.css";

export default function Timeline({ timeLineData }) {
  return (
    <>
      <div className="sm:w-full">
        {timeLineData?.length &&
          timeLineData.map((step, index) => (
            <div key={step.status} className="flex flex-row">
              <div className="flex">
                <div className="relative w-[70px] sm:w-[90px] md:w-[130px]">
                  <div className="absolute right-[12px] top-[14%] translate-y-[-20%] text-right text-[0.813rem] font-medium text-grayDisplay-700 sm:top-[13%] sm:text-[1rem] md:right-[25px] md:top-[50%] md:translate-y-[-45%]">
                    {formatStatus(step.status)}
                  </div>
                </div>

                <div className="relative mr-4 flex flex-col items-center">
                  <div className="absolute top-[13%] md:top-[50%] md:translate-y-[-45%]">
                    <div
                      className={classNames(
                        {
                          "border-primary bg-primary": step.data?.length,
                          "border-grayDisplay-300 bg-white": !step.data?.length,
                        },
                        `flex h-[18px] w-[18px] items-center justify-center rounded-full border-[2px]`
                      )}
                    >
                      <CheckMarkIcon className="text-white" />
                    </div>
                  </div>

                  <div
                    className={
                      `w-[4px] bg-secondary-600 ` +
                      (index === 0
                        ? "mt-auto h-[85%] md:h-[50%]"
                        : index === timeLineData.length - 1
                        ? "h-[15%] md:h-[50%]"
                        : "h-full")
                    }
                  />
                </div>
              </div>
              <div className="flex min-h-[100px] w-full items-center">
                {!!step.data?.length && (
                  <div
                    className={`${Styles.order_details_box} my-[.5rem] w-full space-y-[1.063rem] rounded-xl bg-grayDisplay-500 p-[18px]`}
                  >
                    {step.data.map((content) => (
                      <div
                        key={content.message}
                        className="flex w-full flex-col items-start gap-2 xl:flex-row"
                      >
                        <div className="mb-[0.5rem] text-[0.75rem] text-grayDisplay-800 xl:mb-0 xl:w-[30%] 2xl:w-[20%]">
                          {content.date}
                        </div>
                        <p className="text-[0.875rem] text-grayDisplay-900 xl:w-[70%] 2xl:w-[80%] ">
                          {content.message}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}
